import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { PatientState } from "../../data/atoms";
import { AFScore, RLGLScore, VeggieSlicerScore } from "../../models/reports";
import { convertDOBintoAge, getPatientAge } from "../../utils/sharedFunction";
import CustomBarGraph from "../Graphs/CustomBarGraph";
import TrendlineGraph from "../Graphs/TrendlineGraph";
import TrendLineGraphSvg from "../Graphs/TrendLineGraphSvg";
import { IonGrid, IonRow, IonCol } from "@ionic/react";
import { TestType } from "../../models/Enums";
interface Props {
  score: VeggieSlicerScore;
}

const VeggieSlicer_Test: React.FC<Props> = ({ score }) => {
  const patientInfo = useRecoilValue(PatientState);
  const [reportScore, setReportScore] = useState<VeggieSlicerScore>(score);
  console.log("VeggieSlicer_Test score: ", score);
  const [graphDetails, setGraphDetails] = useState<any>({
    lineGraphValues: [],
    RangeIds: [],
    TestType: TestType.veggie_samurai,
    graphSvg: null,
  });
  const formatNumber = (value: number): string => {
    return Number.isInteger(value) ? value.toString() : value.toFixed(2);
  };
  useEffect(() => {
    setReportScore(score);
  }, [score]);
  return (
    <>
      <IonGrid placeholder={undefined}>
        <IonRow placeholder={undefined}>
          <IonCol placeholder={undefined}>
            <div className="table-heading-wrap">
              <h3>Performance Summary</h3>
              <div className="assessment-info-new-table training-table af-bp-table-cols table first-table">
                <table
                  className="table two-col table-col-{{ table.Columns.length }} table-border-0"
                  aria-describedby="Assessment-Info-Table"
                >
                  <thead className="table-head">
                    <tr>
                      <th scope="col" className="fz-16 fw-700 text-left">
                        Measure
                      </th>
                      <th scope="col" className="fz-16 fw-700">
                        Value
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Score</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>{formatNumber(score.score)}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Score Per Minute</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {!isNaN(score.scorePerMinute)
                            ? formatNumber(score.scorePerMinute)
                            : "-"}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Total Veggies Cut</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {Number.isNaN(score.veggiesCut)
                            ? "-"
                            : formatNumber(score.veggiesCut)}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Total Veggies Missed</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {Number.isNaN(score.veggiesMissed)
                            ? "-"
                            : formatNumber(score.veggiesMissed)}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Percentage of Veggies Cut</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {Number.isNaN(score.veggieAccuracy)
                            ? "-"
                            : Number.isInteger(score.veggieAccuracy)
                            ? formatNumber(score.veggieAccuracy)
                            : formatNumber(score.veggieAccuracy * 100)}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Sponges Cut</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {Number.isNaN(score.spongesCut)
                            ? "-"
                            : formatNumber(score.spongesCut)}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Percentage of Sponges Cut</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {Number.isNaN(score.spongeAccuracy)
                            ? "-"
                            : formatNumber(score.spongeAccuracy * 100)}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="table-heading-wrap">
              <h3>Arm Metrics</h3>
              <div className="assessment-info-new-table training-table af-bp-table-cols table">
                <table
                  className="table three-col table-col-{{ table.Columns.length }} table-border-0"
                  aria-describedby="Assessment-Info-Table"
                >
                  <thead className="table-head">
                    <tr>
                      <th scope="col" className="fz-16 fw-700 text-left">
                        Measure
                      </th>
                      <th scope="col" className="fz-16 fw-700">
                        Left
                      </th>
                      <th scope="col" className="fz-16 fw-700">
                        Right
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Veggies Cut</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {!isNaN(score.left.veggiesCut)
                            ? formatNumber(score.left.veggiesCut)
                            : "-"}
                        </span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {!isNaN(score.right.veggiesCut)
                            ? formatNumber(score.right.veggiesCut)
                            : "-"}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Sponges Cut</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {!isNaN(score.left.spongesCut)
                            ? formatNumber(score.left.spongesCut)
                            : "-"}
                        </span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {!isNaN(score.right.spongesCut)
                            ? formatNumber(score.right.spongesCut)
                            : "-"}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  );
};

export default VeggieSlicer_Test;
